module.exports = __webpack_public_path__ + "static/SquareSerif-Demi-webfont-e29f9813ebb9565e97b845969a1c6ae2.woff";